export default __webpack_public_path__ + "static/media/IMG-20160604-WA0076.dee86feb.jpg";